const Data = [
  {
    name: "Madhushree Dujari",
    position: "UG Coordinator",
    imageUrl: "/assets/images/members/Heads25/MadhushreeDujari.jpeg",
    facebookLink: "",
    linkedinLink: "",
    email: ""
  },
  {
    name: "Puneet Gupta",
    position: "UG Coordinator",
    imageUrl: "/assets/images/members/Heads25/PuneetGupta.jpg",
    facebookLink: "https://www.facebook.com/profile.php?id=100056484364626&mibextid=ZbWKwL",
    linkedinLink: "https://www.linkedin.com/in/puneet-gupta-316579297/",
    email: "puneet.gupta@gyws.org"
  },
  {
    name: "D Saketh Ram",
    position: "UG Coordinator",
    imageUrl: "/assets/images/members/Heads25/DSakethRam.jpg",
    facebookLink: "",
    linkedinLink: "https://www.linkedin.com/in/devanaboyina-saketh-ram-818944298/",
    email: "d.ram@gyws.org"
  }
];

export default Data;